import React, { useState, useEffect, useCallback } from "react";
import { Trans, useTranslation } from "react-i18next";
import { ReactComponent as ChevronRight } from "../../Assets/Icons/chevron-right.svg";
import { ReactComponent as DropboxLogo } from "../../Assets/Images/Integration/dropbox.svg";
import { ReactComponent as IntercomLogo } from "../../Assets/Images/Integration/intercom.svg";
import { ReactComponent as HubspotLogo } from "../../Assets/Images/Integration/hubspot.svg";
import { ReactComponent as JiraLogo } from "../../Assets/Images/Integration/jira.svg";
import { ReactComponent as StrapiLogo } from "../../Assets/Images/Integration/strapi.svg";
import { ReactComponent as ZendeskLogo } from "../../Assets/Images/Integration/zendesk.svg";
import { ReactComponent as ZapierLogo } from "../../Assets/Images/Integration/zapier.svg";
import { ReactComponent as TypeformLogo } from "../../Assets/Images/Integration/typeform.svg";
import { ReactComponent as LugathLogo } from "../../Assets/Icons/logo-t.svg";
import { appsData } from "../../Services/DataService";
import useTranslationEncapsulated from "../../Libs/useTranslation";
import Image from "../../Components/Image";
import { Link } from "react-router-dom";
import "./index.scss";

export default function Integrations({ data, pageName }) {
  const { getTranslatableContent,t, Trans } = useTranslationEncapsulated();
  const integrationItems = appsData.sort(() => .5 - Math.random()).filter((a) => a.keywords.includes(data?.filterType ? data.filterType : "general")).slice(0,8);

  return (
    <section className="bg-integrations js-section_nav-dark">
      <div className="integrations-section container mx-auto">
        <h1 className="integrations-section__title">
          {data?.title ? (
            data?.title
          ) : (
            <Trans
              i18nKey="Commons.Modules.Integrations.Title"
              components={{
                span_highlight: <span className="highlight" />,
              }}
            />
          )}
        </h1>
        
          <p className="integrations-section__desc">
           {data?.description ? data?.description : "Integrates easily with your current platform."}
          </p>
       
        <div className="integrations-section__content">
          <div className="parent">
            <div className="int-card int-card--lugath div1">
              <LugathLogo />
            </div>
            {integrationItems?.map((item, index) => {
             return <div className={`int-card div${index + 2}`}>
                {" "}
                <span className="int-card-logo">
                  <Image
                    fileName={`Assets/Images/Marketplace/${item?.image}`}
                  />
                </span>
                <span className="int-card-desc">{getTranslatableContent(item?.name)}</span>
              </div>;
            })}
          </div>
        </div>
        <div className="integrations-section__link-wrapper">
          <Link className="integrations-section__link" to={"/integrations"}>
            <span className="integrations-section__link-desc">
              {t("Commons.Buttons.ViewAllIntegrations.Text")}
            </span>
            <span className="integrations-section__link-icon">
              <ChevronRight />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
